import React from 'react';
import { Image, ImageProps } from '@chakra-ui/react';

/**
 * A 'lazysizes' lazyloaded image.
 *
 * Configured to only work in windows with window.lazySizesConfig.lazyClass == "remark-lazy-image"
 */
export const ImageWithSrcSet: React.FC<
  Omit<ImageProps, 'srcSet'> & { alt: string; srcSet?: string | null; src: string; sizes?: string }
> = ({ src, srcSet, sizes = 'auto', alt, ...rest }) => (
  <Image
    className="remark-lazy-image"
    data-src={src}
    data-srcset={srcSet ?? undefined}
    data-sizes={sizes}
    alt={alt}
    {...rest}
  />
);
